import { render, staticRenderFns } from "./cardUsuarioContador.vue?vue&type=template&id=36b04029"
import script from "./cardUsuarioContador.vue?vue&type=script&lang=js"
export * from "./cardUsuarioContador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports